<template>
  <div class="base-info">
    <div class="item">
      <span @click="lookData">商品标题：</span>
      <div style="display: flex; align-items: center; flex-wrap: wrap">
        <a-input
          v-model:value="goodsItem.title"
          allowClear
          style="width: 598px; margin-right: 0.6em"
          :class="{ 'title-input': true, error: getModifyTitleLength > 60 }"
          placeholder="请输入商品标题（必填项）"
        >
          <template #addonAfter> {{ getModifyTitleLength }} / 60 </template>
        </a-input>
        <div class="error-msg">
          <span v-show="!getModifyTitleLength">标题是必填项</span>
          <span v-show="getModifyTitleLength > 60">标题已超过 60 个字符，请修改</span>
        </div>
      </div>
    </div>
    <div class="item">
      <span>商品类目：</span>
      <div>
        <a-space>
          <CategoryList :category="goodsItem.category" :categoryList="categoryList" @change="changeCategory" />
          <!-- <span v-show="!goodsItem.category" style="color:red">类目是必选项</span> -->
        </a-space>
      </div>
      <a-button
        type="primary"
        title="如果店铺的分类在支付宝后台有改动过，则需要点击同步类目按钮"
        :loading="loading"
        @click="syncCategory"
      >
        同步类目
      </a-button>
    </div>
    <div class="item align-items-top">
      <span>商品主图：</span>
      <div class="box">
        <div class="zhutu-img">
          <div
            v-for="(item, index) in goodsItem.mainImages"
            :key="item"
            @dragstart="handleDragStart(item)"
            draggable="true"
            @dragenter="handleDragEnter($event, item)"
            @dragover.prevent="handleDragOver"
            @drop.prevent
          >
            <ImageItem
              :item="item"
              :index="index"
              need-msg="比例需1:1"
              @cropper="showVueCropper"
              @delete="deleteImage"
              @upload="showUploadComponent"
            />
          </div>
          <UploadImage
            :id="uploadId + goodsItem.index"
            v-show="goodsItem.mainImages?.length < 5"
            :imgFile="imgFile"
            @upload-image="showVueCropper"
          />
        </div>
      </div>
    </div>
    <div class="btn">
      <span>支持长按图片拖拽交换位置</span>
    </div>
    <div class="zhutu-msg">
      商品主图最多设置5张（格式要求：png、jpg、jpeg格式，图片尺寸至少600x600，比例为1:1，大小不超过2M）
    </div>
    <a-modal
      class="header-fixed-modal"
      width="900px"
      v-model:visible="visible"
      title="裁剪图片"
      :footer="false"
      style="top: 0"
    >
      <CropperImageModal :imgFile="imgFile" @cropper="cropperSuccess" @close="visible = false" />
    </a-modal>
  </div>
</template>
<script>
import CategoryList from "@/views/moving_function/components/mall_category_select2";
import CropperImageModal from "../vue_cropper";
import ImageItem from "../image_item";
import UploadImage from "../upload_image";
//import api from "./api";
import store from "@/store";
import { ShowUploadComponent } from "../utils";
export default {
  components: { CropperImageModal, ImageItem, UploadImage, CategoryList },
  data() {
    return {
      goodsItem: { title: "" },
      imgFile: { index: -1 },
      visible: false,
      uploadId: "main-img-upload-image",
      startItem: [],
      loading: false
    };
  },
  props: {
    categoryList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    getModifyTitleLength() {
      const title = this.goodsItem.title;
      let len = 0;
      for (let i = 0; i < title.length; i++) {
        len += title.charCodeAt(i) > 255 ? 2 : 1;
      }
      return len;
    },
  },
  methods: {
    // 同步类目
    async syncCategory() {
      this.loading = true;
      //const { list, success, msg } = await api.GetGoodsCategoryList(true);
      const { list, success, msg } = await store.dispatch("mall_group/getMallCategory");
      const str = "同步店铺类目";
      if (!success) this.$message.warn(`${str}失败，原因:【${msg}】`);
      else this.$message.success(`${str}成功`);
      this.loading = false;
      this.$emit("sync-category", list);
    },
    showVueCropper(obj) {
      this.visible = true;
      this.imgFile = obj;
    },
    cropperSuccess(imgUrl) {
      // 当 index 为 -1 时说明是添加主图，index 为 10 时说明是白底图
      if (this.imgFile.index === -1 && this.imgFile.index !== 10) {
        this.goodsItem.mainImages.push({});
        this.imgFile.index = this.goodsItem.mainImages.length - 1;
      }
      const obj = this.goodsItem.mainImages[this.imgFile.index];
      const imageElement = new Image();
      obj.img = imgUrl;
      imageElement.src = imgUrl;
      imageElement.onload = () => {
        obj.width = imageElement.width;
        obj.height = imageElement.height;
        obj.isUpdate = true;
      };
      this.visible = false;
      this.imgFile.index = -1;
      this.$message.success("已成功完成裁剪图片");
    },
    deleteImage(index) {
      this.goodsItem.mainImages = this.goodsItem.mainImages.filter((item, i) => i !== index);
      this.$message.success("删除商品主图成功");
    },
    showUploadComponent(obj) {
      ShowUploadComponent(this, obj);
    },
    handleDragStart(item) {
      this.startItem = item; //开始拖动时，暂时保存当前拖动的数据。
    },
    handleDragOver(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = "move"; //为需要移动的元素设置dragstart事件
      if (item == this.startItem) return;
      const newItems = [...this.goodsItem.mainImages]; // 拷贝一份数据进行交换操作。
      const prevIndex = newItems.indexOf(this.startItem); // 获取上一个下标
      const nextIndex = newItems.indexOf(item); // 获取下一个下标
      newItems[prevIndex] = item;
      newItems[nextIndex] = this.startItem;
      this.goodsItem.mainImages = newItems;
    },
    handleDragEnd(e, item) {
      e.preventDefault();
      e.dataTransfer.effectAllowed = "move"; // 为需要移动的元素设置dragstart事件
      if (item == this.startItem) return;
      const newItems = [...this.goodsItem.mainImages]; // 拷贝一份数据进行交换操作。
      const prevIndex = newItems.indexOf(this.startItem); // 获取数组下标
      const nextIndex = newItems.indexOf(item);
      newItems[prevIndex] = item;
      newItems[nextIndex] = this.startItem;
      this.goodsItem.mainImages = newItems;
      this.startItem = null; // 拖动结束后，清除数据
    },
    changeCategory(category) {
      this.goodsItem.category = category;
    },
    lookData() {
      console.log("goodsData...", this.goodsItem);
    },
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
<style lang="less">
.ant-modal.header-fixed-modal {
  .ant-modal-header {
    position: sticky;
    top: 0;
    z-index: 10000;
    padding: 7px 24px;
  }
  .ant-modal-body {
    padding: 12px;
  }
}
</style>
